<template>
  <dara-single-content-layout container-size="lg">
    <template #content>
      <div class="d-flex align-items--center direction--column">
        <dara-icon size="xxl" icon="person-x-fill" />
        <dara-header v-if="creating">{{ $t('you-cant-create-a-user') }}</dara-header>
        <dara-header v-else>{{ $t('you-cant-edit-a-user') }}</dara-header>
        <dara-p>
          {{ $t('you-dont-have-the-right-permission-to-it') }}
        </dara-p>
        <br>
        <dara-button theme="primary" @click="goToBasePage()">
          {{ $t('return-to-page') }}
        </dara-button>
      </div>
    </template>
  </dara-single-content-layout>
</template>

<script>
import { goToBasePage } from '@/router/route.service';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraUserForbiddenPage',
  components: {
    DaraSingleContentLayout,
  },
  computed: {
    creating() {
      return this.$route.params?.creating;
    },
  },
  methods: {
    goToBasePage,
  },
};
</script>
